import script from "./ListarSubcontas.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarSubcontas.vue?vue&type=script&setup=true&lang=js"

import "./ListarSubcontas.vue?vue&type=style&index=0&id=cc85889c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc85889c"]])

export default __exports__